import { CaretRightIcon } from "@phosphor-icons/react";

const TaskOption = ({ innerProps, tasks, sections, isFocused, className, ...props }) => {
    const task = props.data;
    const isSubtask = task.parentId !== null;
    const parent = isSubtask ? tasks.find((t) => t.id === task.parentId) : null;
    const section = sections.find((s) => s.id === task.sectionId);

    return (
        <div {...innerProps} className={`c-task${className ? ` ${className}` : ''}`}>
            <div className="c-task__content">
                <div className="c-task__header">
                    <span className="c-task__section">{section.name}</span>
                    {isSubtask && (
                        <>
                            <CaretRightIcon size={8} weight="bold" color="#a1a1a1" />
                            <span className="c-task__parent">{parent.name}</span>
                        </>
                    )}
                </div>
                <span className="c-task__name">{task.name}</span>
            </div>
        </div>
    );
};

export default TaskOption;
